export default __webpack_public_path__ + "static/media/passport.de227c81.webp";